import LineIcon from './line-icon';
export default LineIcon;
